import React, { ReactElement, createContext, useContext } from 'react';
import {
	LoggerContext,
	PreviewContext,
	useCDNTrackingToLogs,
	ScriptTagContext,
	useCampaignsFiltration,
} from '@rmc/webcx-web-libs';
import { getMainAppInfo } from '../../components/MainApp/utils';
import { useCampaignsApiGet } from '../../api/campaigns';
import {
	API_KEY_EVENT_LOGGER,
	API_URL_EVENT_LOGGER,
	RAT_PROJECT_KEY,
	VERSION,
} from '../../config';

type CampaignsContextType = {
	campaignIdCorrelationInfo: {
		campaignId: string;
		correlationId?: string | null;
	}[];
	error: unknown;
	isLoading: boolean;
};

type ProviderPropsType = { children?: ReactElement };

export const CampaignsContext = createContext<CampaignsContextType>({
	campaignIdCorrelationInfo: [],
	error: null,
	isLoading: true,
});

export function CampaignsProvider({ children }: ProviderPropsType) {
	const { clientId } = useContext(ScriptTagContext);
	const previewQuery = useContext(PreviewContext);
	const { updateGlobalLog } = useContext(LoggerContext);
	const { sessionId, userId, isMobile } = getMainAppInfo();

	const isPreview = Object.keys(previewQuery).length !== 0;

	const {
		data: jsonCampaigns = [],
		error,
		isLoading,
	} = useCampaignsApiGet({ clientId, isPreview });

	useCDNTrackingToLogs({
		projectKey: RAT_PROJECT_KEY,
		version: VERSION,
		error,
		data: jsonCampaigns,
		isLoading,
		sessionId,
		clientId,
		userId,
		isMobile,
		pageUrl: window.location.href || '',
		eventLoggerUrl: API_URL_EVENT_LOGGER,
		eventLoggerApiKey: API_KEY_EVENT_LOGGER,
	});

	const context = useCampaignsFiltration({
		jsonCampaigns,
		error,
		isFetching: isLoading,
		log: updateGlobalLog,
	});

	return (
		<CampaignsContext.Provider value={context}>
			{children}
		</CampaignsContext.Provider>
	);
}
